import React from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Grid,
  Box,
  styled
} from '@mui/material';
import {
  Timeline as TimelineIcon,
  Refresh as RefreshIcon,
  Description as DescriptionIcon,
  ArrowBack as ArrowBackIcon
} from '@mui/icons-material';

const StyledButton = styled(Button)(({ theme }) => ({
  margin: theme.spacing(1),
}));

const ActionButton = styled(Button)(({ theme }) => ({
  margin: theme.spacing(1),
  textTransform: 'uppercase',
}));

export default function ContractDetails() {
  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="static" color="default">
        <Toolbar>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} sm={true}>
              <StyledButton variant="contained" color="primary" startIcon={<TimelineIcon />}>
                Cronologia
              </StyledButton>
              <StyledButton variant="contained" color="secondary" startIcon= {<DescriptionIcon />}>
                PDF Hoja de Atencion
              </StyledButton>
              <StyledButton variant="contained" color="primary" startIcon= {<DescriptionIcon />}>
                PDF Contratos
              </StyledButton>
            </Grid>
            <Grid item>
              <StyledButton variant="outlined" startIcon={<ArrowBackIcon />}>
                Volver
              </StyledButton>
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>

      <Card sx={{ mt: 2 }}>
        <CardContent>
          <Grid container justifyContent="space-between" alignItems="center">
            <Grid item>
              <Typography variant="h5" component="h2">
                DETALLES CONTRATO (APROBADO) - VALIDADO
              </Typography>
            </Grid>
            <Grid item>
              <Typography color="textSecondary">
                CODIGO DE CONTRATO: DDLA0420203
              </Typography>
            </Grid>
          </Grid>

          {/*<Box sx={{ mt: 2 }}>
            <ActionButton variant="contained" color="primary">
              Ver Actualizaciones
            </ActionButton>
            <ActionButton variant="contained" color="secondary">
              Ver Tareas
            </ActionButton>
            <ActionButton variant="outlined">
              Desactivar Contrato
            </ActionButton>
          </Box>

          <Box sx={{ mt: 2 }}>
            <ActionButton variant="outlined" color="primary">
              Editar Datos del Cliente
            </ActionButton>
          </Box>*/}

          <Grid container spacing={2} sx={{ mt: 2 }}>
            <Grid item xs={12} md={6}>
              <Typography variant="body1"><strong>Usuario Seleccionado:</strong> Daniela Peñaloza</Typography>
              <Typography variant="body1"><strong>Atendido por:</strong> Daniela Jeanette Peñaloza</Typography>
              <Typography variant="body1"><strong>Nombre Defendido:</strong> Carol Mariol Barraza Martinez</Typography>
              <Typography variant="body1"><strong>Rut Defendido:</strong> 16.701.505-0</Typography>
              <Typography variant="body1"><strong>Telefono:</strong> no tiene</Typography>
              <Typography variant="body1"><strong>Region:</strong> V de Valparaiso</Typography>
              <Typography variant="body1"><strong>Direccion:</strong> Portones del Inca Educador Fernando Palma Oriente,693,San Felipe</Typography>
              <Typography variant="body1"><strong>Monto Acordado Contrato:</strong> $1.000.000</Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography variant="body1"><strong>Fecha/Hora Atencion:</strong> 09/04/2020 17:59</Typography>
              <Typography variant="body1"><strong>Nombre Pagador:</strong> Carol Barraza</Typography>
              <Typography variant="body1"><strong>Rut Pagador:</strong> 16.701.505-0</Typography>
              <Typography variant="body1"><strong>Celular:</strong> 995338484</Typography>
              <Typography variant="body1"><strong>Email:</strong> distribuidorasimoneirl@gmail.com</Typography>
            </Grid>
          </Grid>

          <TableContainer component={Paper} sx={{ mt: 4 }}>
            <Table>
              <TableHead>
                <TableRow >
                  <TableCell>LINEA DE NEGOCIO</TableCell>
                  <TableCell>SERVICIO</TableCell>
                  <TableCell>COSTO SERVICIO</TableCell>
                  <TableCell>ACCIONES</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell>Defensa Deudores</TableCell>
                  <TableCell>Cesación de Pago</TableCell>
                  <TableCell>$1.000.000</TableCell>
                  <TableCell>
                    <ActionButton variant="contained" color="secondary" size="small">
                      Ver Acreedores
                    </ActionButton>
                    <ActionButton variant="contained" color="primary" size="small">
                      Descarga Consentimiento
                    </ActionButton>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell colSpan={2}>Total Servicios:</TableCell>
                  <TableCell>$1.000.000</TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>

          <TableContainer component={Paper} sx={{ mt: 4 }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>N° CUOTAS</TableCell>
                  <TableCell>FECHA DE PAGO</TableCell>
                  <TableCell>MONTO</TableCell>
                  <TableCell>ESTADO CUOTA</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell>1</TableCell>
                  <TableCell>30/05/2020</TableCell>
                  <TableCell>$ 40.000 CLP</TableCell>
                  <TableCell>Sin Pagar</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </CardContent>
      </Card>
    </Box>
  );
}